import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { BiErrorCircle, BiCheckCircle, BiInfoCircle, BiX } from "react-icons/bi";
import HeaderCard from "../../components/Header/HeaderCard";

const Paie = () => {
    const { t, i18n } = useTranslation();
    const dateLocale = i18n.resolvedLanguage?.startsWith('en') ? 'en-US' : 'fr-FR';
    const [notes, setNotes] = useState("");
    const [checked, setChecked] = useState(false);
    const today = new Date();


    const [notifications, setNotifications] = useState([
        { id: 1, type: "danger", message: t('paieHome.notifContractEnding') },
        { id: 2, type: "warning", message: t('paieHome.notifSoftwareUpdate') },
        { id: 3, type: "success", message: t('paieHome.notifNewProcess') },
    ]);

    const removeNotification = (id) => {
        setNotifications(notifications.filter((notif) => notif.id !== id));
    };

    const getIcon = (type) => {
        switch (type) {
            case "danger":
                return <BiErrorCircle className="text-red-600 text-2xl" />;
            case "warning":
                return <BiInfoCircle className="text-yellow-500 text-2xl" />;
            case "success":
                return <BiCheckCircle className="text-green-500 text-2xl" />;
            default:
                return <BiInfoCircle className="text-gray-500 text-2xl" />;
        }
    };

    const getBackground = (type) => {
        switch (type) {
            case "danger":
                return "bg-red-100 border-l-4 border-red-500 text-red-800";
            case "warning":
                return "bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800";
            case "success":
                return "bg-green-100 border-l-4 border-green-500 text-green-800";
            default:
                return "bg-gray-100 border-l-4 border-gray-500 text-gray-800";
        }
    };


    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="container h-screen mx-auto p-6"
        >
            <HeaderCard
                title={t('paieHome.welcome')}
                text={t('paieHome.summary', { month: today.toLocaleString(dateLocale, { month: "long" }), year: today.getFullYear() })}
            />

            <div>
                <h2 className="text-2xl font-semibold mb-4">{t('paieHome.notificationsAndAlerts')}</h2>
                <div className="space-y-3">
                    <AnimatePresence>
                        {notifications.map((notif) => (
                            <motion.div
                                key={notif.id}
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 20 }}
                                transition={{ duration: 0.3 }}
                                className={`p-4 rounded-lg shadow ${getBackground(notif.type)} flex items-center justify-between`}
                            >
                                <div className="flex items-center">
                                    {getIcon(notif.type)}
                                    <span className="ml-3">{notif.message}</span>
                                </div>
                                <button onClick={() => removeNotification(notif.id)}>
                                    <BiX className="text-gray-600 text-2xl hover:text-gray-900" />
                                </button>
                            </motion.div>
                        ))}
                    </AnimatePresence>
                </div>
            </div>

            <div className="mt-6 grid grid-cols-1">

            {/* Récapitulatif */}
            <motion.div
                whileHover={{ scale: 1.02 }}
                className="bg-white p-6 rounded-xl shadow-lg"
            >
                <h2 className="text-2xl font-semibold mb-4">{t('paieHome.yourPayrollOf', { month: today.toLocaleString(dateLocale, { month: "long" }), year: today.getFullYear() })}</h2>

            </motion.div>

            </div>

            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">

                {/* Récapitulatif */}
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="bg-white p-6 rounded-xl shadow-lg"
                >
                    <h2 className="text-2xl font-semibold mb-4">{t('paieHome.boardSummary')}</h2>
                    <p className="text-gray-700 mb-4">
                        {t('paieHome.boardSummaryDetail')}
                    </p>
                    <h3 className="text-lg font-medium mb-2">{t('paieHome.onDate')}</h3>
                    <ul className="list-disc list-inside text-gray-800">
                        <li>{t('paieHome.todoRecordDocs')}</li>
                        <li>{t('paieHome.todoIndexSalaries')}</li>
                        <li>{t('paieHome.todoNewContract')}</li>
                    </ul>
                    <div className="mt-4 flex items-center">
                        <input
                            type="checkbox"
                            className="checkbox checkbox-primary"
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        />
                        <label htmlFor="assurance" className="ml-2 text-gray-700">
                            {t('paieHome.giveInsuranceCard')}
                        </label>
                    </div>
                </motion.div>

                {/* Notes */}
                <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="bg-white p-6 rounded-xl shadow-lg"
                >
                    <h2 className="text-2xl font-semibold mb-4">{t('paieHome.notes')}</h2>
                    <textarea
                        className="w-full p-2 border rounded"
                        rows="6"
                        placeholder={t('paieHome.addNotePlaceholder')}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    ></textarea>
                </motion.div>

                </div>
        </motion.div>
    );
};

export default Paie;
